export default "dist/images/block-card-faded.9ebff54.png";